import React, { useState } from 'react';
import styles from './Footer.module.css';
import TermsAndPrivacyModal from '../../modals/LoginModal/TermsAndPrivacyModal';

const Footer = () => {
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [showAboutModal, setShowAboutModal] = useState(false);
  const [showHowItWorksModal, setShowHowItWorksModal] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);


  return (
    <>
      <footer className={styles.footer}>
        <div className={styles.footerContent}>
          <div className={styles.footerColumn}>
            <h4>About I'm Selling</h4>
            <button onClick={() => setShowAboutModal(true)} className={styles.footerLink}>About Us</button>
            <button onClick={() => setShowHowItWorksModal(true)} className={styles.footerLink}>How It Works</button>
            <a href="#">Careers</a>
          </div>
          <div className={styles.footerColumn}>
            <h4>Support</h4>
            <a href="#">Help Center</a>
            <a href="#">Safety Tips</a>
            <button onClick={() => setShowContactModal(true)} className={styles.footerLink}>Contact Us</button>
          </div>
          <div className={styles.footerColumn}>
            <h4>Legal</h4>
            <button onClick={() => setShowTermsModal(true)} className={styles.footerLink}>Terms & Conditions</button>
            <button onClick={() => setShowTermsModal(true)} className={styles.footerLink}>Privacy Policy</button>
            <a href="#">Cookie Policy</a>
            <a href="#">Sitemap</a>
          </div>
          <div className={styles.footerColumn}>
            <h4>Connect With Us</h4>
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">Facebook</a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">Twitter</a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">Instagram</a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">LinkedIn</a>
          </div>
        </div>
        <div className={styles.footerBottom}>
          © 2026 I'm Selling - All Rights Reserved.
        </div>
      </footer>

      {/* Terms & Privacy Modal */}
      <TermsAndPrivacyModal
        isOpen={showTermsModal}
        onClose={() => setShowTermsModal(false)}
      />

      {/* About Us Modal */}
      {showAboutModal && (
        <div className={styles.modalOverlay} onClick={() => setShowAboutModal(false)}>
          <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <button className={styles.modalClose} onClick={() => setShowAboutModal(false)}>×</button>
            <h2 className={styles.modalTitle}>About I'm Selling</h2>
            <div className={styles.modalBody}>
              <p>
                <strong>Welcome to I'm Selling</strong> - Kenya's premier online marketplace connecting buyers and sellers across the country.
              </p>
              
              <h3>Our Mission</h3>
              <p>
                To provide a safe, reliable, and user-friendly platform where Kenyans can buy and sell anything, anywhere, anytime. We believe in empowering local commerce and making transactions as simple and secure as possible.
              </p>

              <h3>What We Offer</h3>
              <ul>
                <li><strong>Wide Range of Categories:</strong> From electronics and vehicles to real estate and services</li>
                <li><strong>Secure Platform:</strong> Advanced security measures to protect your transactions</li>
                <li><strong>Easy Communication:</strong> Direct messaging between buyers and sellers</li>
                <li><strong>Mobile-Friendly:</strong> Access the platform from any device</li>
                <li><strong>Local Focus:</strong> Supporting Kenyan businesses and individuals</li>
              </ul>

              <h3>Our Values</h3>
              <ul>
                <li><strong>Trust:</strong> Building a community based on transparency and reliability</li>
                <li><strong>Innovation:</strong> Continuously improving our platform for better user experience</li>
                <li><strong>Community:</strong> Creating connections that strengthen local commerce</li>
                <li><strong>Safety:</strong> Prioritizing the security of every transaction</li>
              </ul>

              <p>
                Since our launch, we've helped thousands of Kenyans connect, trade, and grow their businesses. Join our community today and experience the future of online commerce in Kenya!
              </p>
            </div>
          </div>
        </div>
      )}

      {/* How It Works Modal */}
      {showHowItWorksModal && (
        <div className={styles.modalOverlay} onClick={() => setShowHowItWorksModal(false)}>
          <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <button className={styles.modalClose} onClick={() => setShowHowItWorksModal(false)}>×</button>
            <h2 className={styles.modalTitle}>How It Works</h2>
            <div className={styles.modalBody}>
              <p className={styles.intro}>
                Getting started on I'm Selling is easy! Follow these simple steps to buy or sell items:
              </p>

              <div className={styles.stepSection}>
                <h3>🛍️ For Buyers</h3>
                <div className={styles.step}>
                  <span className={styles.stepNumber}>1</span>
                  <div>
                    <h4>Browse or Search</h4>
                    <p>Explore categories or use the search bar to find what you're looking for</p>
                  </div>
                </div>
                <div className={styles.step}>
                  <span className={styles.stepNumber}>2</span>
                  <div>
                    <h4>Contact the Seller</h4>
                    <p>Click on an item to view details and contact the seller directly</p>
                  </div>
                </div>
                <div className={styles.step}>
                  <span className={styles.stepNumber}>3</span>
                  <div>
                    <h4>Negotiate & Meet</h4>
                    <p>Discuss price, arrange viewing, and meet in a safe public place</p>
                  </div>
                </div>
                <div className={styles.step}>
                  <span className={styles.stepNumber}>4</span>
                  <div>
                    <h4>Complete Purchase</h4>
                    <p>Inspect the item, make payment, and complete the transaction safely</p>
                  </div>
                </div>
              </div>

              <div className={styles.stepSection}>
                <h3>💰 For Sellers</h3>
                <div className={styles.step}>
                  <span className={styles.stepNumber}>1</span>
                  <div>
                    <h4>Create an Account</h4>
                    <p>Sign up for free and verify your account</p>
                  </div>
                </div>
                <div className={styles.step}>
                  <span className={styles.stepNumber}>2</span>
                  <div>
                    <h4>Post Your Ad</h4>
                    <p>Click "Post an Ad", add photos, description, and set your price</p>
                  </div>
                </div>
                <div className={styles.step}>
                  <span className={styles.stepNumber}>3</span>
                  <div>
                    <h4>Respond to Inquiries</h4>
                    <p>Answer questions from potential buyers promptly</p>
                  </div>
                </div>
                <div className={styles.step}>
                  <span className={styles.stepNumber}>4</span>
                  <div>
                    <h4>Meet & Sell</h4>
                    <p>Arrange a safe meeting place and complete the sale</p>
                  </div>
                </div>
              </div>

              <div className={styles.safetyTips}>
                <h3>🛡️ Safety Tips</h3>
                <ul>
                  <li>Always meet in public, well-lit places</li>
                  <li>Inspect items carefully before purchasing</li>
                  <li>Never share personal financial information</li>
                  <li>Trust your instincts - if something feels wrong, walk away</li>
                  <li>Report suspicious activity to our support team</li>
                </ul>
              </div>

              <p className={styles.outro}>
                Ready to get started? <strong>Post your first ad or start browsing now!</strong>
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Contact Us Modal */}
      {showContactModal && (
        <div className={styles.modalOverlay} onClick={() => setShowContactModal(false)}>
          <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <button className={styles.modalClose} onClick={() => setShowContactModal(false)}>×</button>
            <h2 className={styles.modalTitle}>Contact Us</h2>
            <div className={styles.modalBody}>
              <p>📧 <a href="mailto:kosgeienock97@gmail.com">kosgeienock97@gmail.com</a></p>
              <p>📞 <a href="tel:+254113361891">+254 113 361 891</a></p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Footer;

